/**
 * Groups availability times into buckets keyed by their display label. Pure and shared: the
 * command layer (`toTimePickerTimes`) and the availability store's auto-select derivation
 * (`autoDefaultTime`) both fold times through this, so it lives as a leaf util rather than on
 * either — a store must never reach into a command, and duplicating it invites drift.
 */
export function groupTimesByLabel(availability: AvailabilityTime[]): Record<string, AvailabilityTime[]> {
  return availability.reduce((acc: Record<string, AvailabilityTime[]>, time) => {
    // "anytime" slots must be grouped separately so they never share a label
    // with a fixed-time slot that happens to start at the same hour (like start of day for the partner)
    const key = time.duration?.length?.unit === 'FLEXIBLE' ? 'Anytime' : time.time
    acc[key] ??= []
    acc[key]!.push(time)
    return acc
  }, {})
}
